<div class="paymentGateway" [@enter] [@leave]>
    <app-banner></app-banner>
    <app-payment-methods></app-payment-methods>
    <app-payment-slider></app-payment-slider>
    <app-platforms></app-platforms>
    <!-- <app-card-payments [isReverse] = "isreverse" ></app-card-payments> -->
    <app-tailored-solution></app-tailored-solution>
</div>